import React, { useState, useEffect, useMemo } from "react";
import "../../styles/pagelayout.scss";
import "./PartnerProfile.scss";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Auth from "@aws-amplify/auth";
import Cookies from "js-cookie";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "../components/sidebar/Sidebar";
import Navbar from "../components/header/NavBar";
import BreadCrumb from "../components/header/BreadCrumb";
import { GetUserProfile } from "../../API/endpoints/User";
import { useLocation } from "react-router-dom";
import {
  GetPermissionsByRoleAndModuleID,
  GetRoleById,
} from "../../API/endpoints/RolesAndPermissions/Roles";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import { Typography } from "@mui/material";
import Chip from "@mui/material/Chip";
import { SelectChangeEvent } from "@mui/material/Select";
import {
  AcceptPartnerInterest,
  GetAllServices,
  getDiscoveryMarketByPartner,
  getDiscoveryPartnerByID,
} from "../../API/endpoints/Discovery";
import { MarkTodoDone } from "../../API/endpoints/Todos";
import ConfirmModal from "../components/Modal/ConfirmModal";
import ToastMessage from "../components/toasts/ToastMessage";
import BrandApprovalPartner from "../components/modalForms/DiscoveryManagement/BrandApprovePartner";
import { getFlagIcon, getPartnerStatusTextStyle } from "../../common/helpers";
import DocumentItem from "../components/documentItem/DocumentItem";
import {
  getConsultantsByPartnerID,
  getPartnerByID,
  getPartnerFile,
} from "../../API/endpoints/Partner";
import PartnerDropDown from "./PartnerDropDown";
import PartnerChat from "../DiscoveryManagement/PartnerChat";
import { EngagementModelDTO } from "../dtos/brand.dtos";
import { GetEngagementModels } from "../../API/endpoints/Brands";
import { GetCategories } from "../../API/endpoints/Common";

const DiscoveryPartnerProfile = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const tableName = location.state;

  const [userID, setUserID] = useState<string | undefined>("");
  const [userProfile, setUserProfile] = useState<any>({});
  const [roleID, setRoleID] = useState<number>(0);
  const [userType, setUserType] = useState("");
  const [permissions, setPermissions] = useState<any[]>([]);
  const [partnerData, setPartnerData] = useState<any>({});
  const [market, setMarket] = useState<any>([]);
  const [acceptInterestModal, setAcceptIneterestModal] = useState(false);
  const [notification, setNotification] = useState({ type: "", msg: "" });
  const [showRecommendModal, setShowRecommendModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState({});
  const [marketsList, setMarketsList] = useState<any>([]);
  const [servicesList, setServicesList] = useState<any[]>([]);
  const [flag, setFlag] = useState(false);
  const [partnerConsultants, setPartnerConsultants] = useState<any>([]);
  const [documents, setDocuments] = useState<any>([]);
  const [showChatModal, setShowChatModal] = useState(false);
  const [chatData, setChatData] = useState({} as any);

  const [engagementModels, setEngagementModels] = useState<
    EngagementModelDTO[]
  >([]);
  const [categories, setCategories] = useState<any[]>([]);

  const handleCloseRecommend = () => setShowRecommendModal(false);

  function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }
  // const [openMarket, setOpenMarket] = React.useState(false);
  const [age, setAge] = React.useState("");

  function stringAvatar(name: string) {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: name
        ? name
            .split(" ")
            ?.map(function (str) {
              return str ? str[0].toUpperCase() : "";
            })
            .join("")
        : "",
    };
  }

  useEffect(() => {
    setUserID(Cookies.get("userID"));
    getServicesList();
    getEngagementModelsList();
    (async () => {
      try {
        const response = await GetCategories();
        setCategories(
          response.data.map((item: any) => {
            return { ...item, id: item.display_name };
          })
        );
      } catch (error) {}
    })();
  }, []);

  useEffect(() => {
    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          setRoleID(response.data?.user_roles[0]?.roles.id);
          setUserProfile(response?.data);
        }
      })();
    }
  }, [userID, navigate]);

  useEffect(() => {
    (async () => {
      const roleDetails = await GetRoleById(roleID?.toString());
      setUserType(roleDetails?.data?.role_name);
      if (roleDetails?.data?.type === "administrative") {
        const response = await GetPermissionsByRoleAndModuleID(
          roleID.toString(),
          "4"
        );
        console.log(response);
        setPermissions(response?.data);
      }
    })();
  }, [roleID]);

  useEffect(() => {
    (async () => {
      try {
        const res =
          tableName === "suitable"
            ? await getPartnerByID(params.partnerId)
            : await getDiscoveryPartnerByID(tableName as any);

        const consultants = await getConsultantsByPartnerID(params.partnerId);
        setPartnerConsultants(consultants.data.rows);
        const response = await getPartnerFile(params.partnerId);
        setDocuments(response.data);

        const marketReq = {
          partner_id: params?.partnerId,
          country: params?.marketId,
        };
        console.log("dsicovery partner", res.data);
        let statusText = res.data?.status;
        if (res.data?.status === "Completed") {
          statusText = "Accepted";
        } else if (
          res?.data?.partner_recommendation_status &&
          res?.data?.partner_recommendation_status === "Recommended"
        ) {
          statusText = "Recommended";
        } else {
          statusText = tableName === "suitable" ? "Suitable" : "Interested";
        }
        setPartnerData({ ...res.data, statusText: statusText });
        setSelectedRequest({
          brandid: "",
          partner_services: res.data?.partner_services
            ? res.data?.partner_services
            : [],
          discovery_brands_id: res?.data?.discovery_brands_id,
          id: res?.data?.id,
          partner_id: res?.data?.partnerv2_id,
          focusmarket: params?.marketId,
          partnerName: res?.data?.partnerv2?.name,
          servicerequestIds: res.data?.partner_services?.map(
            (service: { service_id: any }) => {
              return service.service_id;
            }
          ),
          serviceRequests: res.data.partner_services?.map(
            (service: { service_id: number }) => {
              if (service.service_id === 1) return "Requlatory Compliance";
              if (service.service_id === 2) return "Importation and Clearance";
              if (service.service_id === 3) return "Warehousing And Storage";
              if (service.service_id === 4)
                return "Ecommerce Setup & Management";
              if (service.service_id === 5) return "Retail Distribution";
              if (service.service_id === 6) return "Order Fulfillment";
              if (service.service_id === 7) return "Marketing";
              return "";
            }
          ),
        });

        const market = await getDiscoveryMarketByPartner(marketReq);
        console.log("dsicovery market", market.data);
        setMarket(
          market?.data?.rows?.filter(
            (item: any) => item?.country?.id === Number(params?.marketId)
          )
        );
      } catch (error) {}
    })();
  }, [params, flag]);

  const breadcrumbData = [
    {
      name: "Discovery Management",
      onClick: () => {
        navigate(-2);
      },
      active: false,
    },
    {
      name: params?.brandName || "",
      url: "",
      onClick: () => {
        navigate(-1);
      },
      active: false,
    },
    {
      name: partnerData?.partnerv2?.name
        ? partnerData?.partnerv2?.name
        : partnerData?.name
        ? partnerData?.name
        : "",
      url: ``,
      active: true,
    },
  ];

  const handleAcceptInterest = () => {
    setAcceptIneterestModal(true);
  };
  const closeAcceptInterestModal = () => {
    setAcceptIneterestModal(false);
  };
  const onAcceptInterest = async () => {
    const formData = {
      discovery_brands_id: partnerData?.discovery_brands_id,
      discovery_partners_id: partnerData?.id,
      partner_id: partnerData?.partnerv2_id,
      services: partnerData?.partner_services?.map(
        (service: any) => service.service_id
      ),
    };

    try {
      const res = await AcceptPartnerInterest(formData);
      // try {
      //   const activity = await CreateActivity(
      //     `Brand: ${brandName} has accepted service request from partner: ${partnerName}.`
      //   );
      //   console.log(activity);
      // } catch (err: any) {
      //   console.log(err);
      // }
      try {
        const todoDone1 = await MarkTodoDone(
          `partner-request-created:${formData.discovery_brands_id}`
        );
        console.log(todoDone1);
      } catch (ex: any) {
        console.log(ex);
      }

      try {
        const todoDone2 = await MarkTodoDone(
          `partner-interest:${formData.discovery_partners_id}`
        );
        console.log(todoDone2);
      } catch (ex: any) {
        console.log(ex);
      }

      try {
        const todoDone3 = await MarkTodoDone(
          `partner-interest-admin:${formData.discovery_partners_id}`
        );
        console.log(todoDone3);
      } catch (ex: any) {
        console.log(ex);
      }

      try {
        const todoDone4 = await MarkTodoDone(
          `partner-interest-partner:${formData.discovery_partners_id}`
        );
        console.log(todoDone4);
      } catch (ex: any) {
        console.log(ex);
      }

      try {
        const todoDone5 = await MarkTodoDone(
          `partner-recommended:${formData.partner_id}&&${formData.discovery_brands_id}`
        );
        console.log(todoDone5);
      } catch (ex: any) {
        console.log(ex);
      }

      try {
        const todoDone6 = await MarkTodoDone(
          `partner-recommended-admin:${formData.partner_id}&&${formData.discovery_brands_id}`
        );
        console.log(todoDone6);
      } catch (ex: any) {
        console.log(ex);
      }

      console.log(res);
      setAcceptIneterestModal(false);
      setFlag(!flag);
    } catch (err: any) {
      console.log(err);
      setAcceptIneterestModal(false);
    }
  };

  const getServicesList = async () => {
    const response = await GetAllServices();
    if (response) {
      const postServices: any[] = response?.data?.post_launch_service;
      const preServices: any[] = response?.data?.pre_launch_service;
      setServicesList([...postServices, ...preServices]);
    }
  };

  const getEngagementModelsList = async () => {
    const response = await GetEngagementModels();
    if (response) {
      setEngagementModels(response.data);
    }
  };

  const handleRecommend = () => {
    setShowRecommendModal(true);
  };

  const handleCloseNotification = () =>
    setNotification({
      type: "",
      msg: "",
    });

  const marketServicesList = (services: string[]) => {
    return services?.map((service: any) => {
      let serviceName = servicesList?.find(
        (item: any) => item?.name === service
      )?.display_name;
      return (
        <Col className="my-8" key={service?.id} md="auto">
          <Chip
            sx={{
              padding: "8px",
              marginRight: "8px",
              fontWeight: "400",
              width: "auto",
              background: "#F9FAFB",
              borderRadius: "2px",
              color: "#475467",
              fontSize: "12px",
            }}
            size="small"
            label={serviceName}
          />
        </Col>
      );
    });
  };

  const categoriesList = (cats: any[]) => {
    if (tableName === "suitable") {
      return cats
        .map((c: string) => {
          let cName = categories?.find((item: any) => item?.id === c)?.name;
          return cName;
        })
        .join(", ");
    } else {
      return cats?.map((cat) => cat).join(", ");
    }
  };

  const engagementModelList = (models: any[]) => {
    if (tableName === "suitable") {
      return models
        .map((c: string) => {
          let cName = engagementModels?.find(
            (item: any) => item?.name === c
          )?.display_name;

          console.log("cName", cName);

          return cName;
        })
        .join(", ");
    } else {
      return models?.map((model) => model).join(", ");
    }
  };

  const shipmentTermsList = (items: any[]) => {
    return items?.map((cat) => cat).join(", ");
  };

  const paymentTermList = (items: any[]) => {
    return items?.map((cat) => cat).join(", ");
  };

  const capabilitiesList = useMemo(
    () =>
      market?.map((market: any, index: number) => {
        return (
          <Accordion defaultExpanded={index == 0} key={index}>
            <AccordionSummary
              sx={{
                pointerEvents: "none",
              }}
              expandIcon={
                <ExpandMoreIcon
                  sx={{
                    pointerEvents: "auto",
                  }}
                />
              }
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <div
                className="align-center fullwidth d-flex pl20px borderbottom"
                style={{ padding: "6px 12px" }}
              >
                {getFlagIcon(market?.country?.name)}
                <Typography className="mx-05">
                  {market?.country?.name}
                </Typography>
                <Chip
                  size="small"
                  label={`${String(
                    market?.service_capabilities
                      ? market?.service_capabilities.length
                      : 0
                  ).padStart(2, "0")} ${
                    market?.services?.length == 1
                      ? "Capability"
                      : "Capabilities"
                  }`}
                />
                <div className="ml-auto pos">
                  {userProfile?.user_type !== "organization" ? (
                    <PartnerDropDown
                      reviewOnly={true}
                      marketID={market?.id}
                      partnerID={
                        partnerData?.partnerv2_id
                          ? partnerData.partnerv2_id
                          : partnerData?.id
                          ? partnerData.id
                          : ""
                      }
                      country={market?.country?.id}
                      brandName={params?.brandName}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <Row className="row-input p-20">
                <Col sm={4} md={4} lg={4}>
                  <Row className="my-8">
                    <Typography
                      sx={{
                        fontWeight: "500",
                        borderRadius: "2px",
                        color: "#667085",
                        fontSize: "12px",
                        padding: "4px",
                      }}
                    >
                      Service Capabilities
                    </Typography>
                  </Row>
                  <Row>{marketServicesList(market?.service_capabilities)}</Row>
                </Col>
                <Col sm={8} md={8} lg={8}>
                  <Row className="my-8">
                    <Col sm={4} md={4} lg={4}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#667085",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        Category Focus
                      </Typography>
                    </Col>
                    <Col>:</Col>
                    <Col sm={7} md={7} lg={7}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#1D2939",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        {categoriesList(market?.category_focus)}
                      </Typography>
                    </Col>
                  </Row>
                  <Row className="my-8">
                    <Col sm={4} md={4} lg={4}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#667085",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        Minimum Tenure
                      </Typography>
                    </Col>
                    <Col>:</Col>
                    <Col sm={7} md={7} lg={7}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#1D2939",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        {market?.minimum_tenure}
                      </Typography>
                    </Col>
                  </Row>
                  <Row className="my-8">
                    <Col sm={4} md={4} lg={4}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#667085",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        Shipment Terms
                      </Typography>
                    </Col>
                    <Col>:</Col>
                    <Col sm={7} md={7} lg={7}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#1D2939",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        {shipmentTermsList(market?.shipment_terms)}
                      </Typography>
                    </Col>
                  </Row>
                  <Row className="my-8">
                    <Col sm={4} md={4} lg={4}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#667085",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        Engagement Model
                      </Typography>
                    </Col>
                    <Col>:</Col>
                    <Col sm={7} md={7} lg={7}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#1D2939",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        {engagementModelList(market?.engagement_model)}
                      </Typography>
                    </Col>
                  </Row>
                  <Row className="my-8">
                    <Col sm={4} md={4} lg={4}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#667085",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        Payment Terms
                      </Typography>
                    </Col>
                    <Col>:</Col>
                    <Col sm={7} md={7} lg={7}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#1D2939",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        {paymentTermList(market?.payment_terms)}
                      </Typography>
                    </Col>
                  </Row>
                  <Row className="my-8">
                    <Col sm={4} md={4} lg={4}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#667085",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        Exclusivity
                      </Typography>
                    </Col>
                    <Col>:</Col>
                    <Col sm={7} md={7} lg={7}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#1D2939",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        {market?.exclusivity == true ? "Yes" : "No"}
                      </Typography>
                    </Col>
                  </Row>
                  <Row className="my-8">
                    <Col sm={4} md={4} lg={4}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#667085",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        Trade and Marketing Investments
                      </Typography>
                    </Col>
                    <Col>:</Col>
                    <Col sm={7} md={7} lg={7}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#1D2939",
                          fontSize: "12px",
                          padding: "4px",
                          textTransform: "capitalize",
                        }}
                      >
                        {market?.trade_marketing_investments?.toLowerCase()}
                      </Typography>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </AccordionDetails>
            <Col className="bt-gray200 mx-2 py-8">
              <Typography
                sx={{ fontSize: "12px", color: "#667085", marginTop: "10px" }}
              >
                Remarks
              </Typography>
              <Typography sx={{ fontSize: "12px", color: "#667085" }}>
                {market?.remarks}
              </Typography>
            </Col>
          </Accordion>
        );
      }),
    [market, servicesList]
  );

  const documentsList = useMemo(
    () =>
      partnerData?.partnerv2?.partner_documentsv2?.map(
        (doc: any, key: number) => {
          return <DocumentItem name={doc?.file_name} path={doc?.path} />;
        }
      ),
    [partnerData]
  );

  return (
    <Container fluid className="pge-layout">
      <Row>
        <Col className="sidebar">
          <Sidebar active="discovery" />
        </Col>
        <Col className="content-section details-section">
          <Navbar userProfile={userProfile} />
          <BreadCrumb breadcrumbData={breadcrumbData} />

          <Container fluid className="partner-profile">
            <Row className="row-1">
              {/* <Col md={3} lg={3} className="col-profile">
                <img
                  className="img-fluid img-thumbnail profile-pic"
                  src="../images/noimage.jpg"
                  alt="profilepic"
                />
                <div className="name-status">
                  <span className="font16-medium gray-800 mr8px">
                    {partnerData.company_name}
                  </span>
                  <span
                    className={
                      partnerData?.status === "Activated"
                        ? "success-status font12-medium"
                        : "blue-status font12-medium"
                    }
                  >
                    {partnerData?.status}
                  </span>
                </div>
                {partnerData?.website && (
                  <div className="mt8px">
                    <img
                      className="mr6px"
                      width="16px"
                      height="16px"
                      src="../svgs/globe.svg"
                      alt="globe"
                    />
                    <a
                      className="font12-regular"
                      href={`https://${partnerData.website}`}
                      rel="noreferrer"
                      target="_blank"
                    >
                      {partnerData.website}
                    </a>
                  </div>
                )}
                {partnerData?.partner_categories?.length !== 0 && (
                  <div className="focus-cat mt16px">
                    {partnerData?.partner_categories?.map((item: any) => {
                      return (
                        <div key={item.id} className="cat">
                          <span className="font12-regular gray-600">
                            {item.categories.name}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </Col> */}
              {/* <Col className="col-basicinfo">
                <table>
                  <tbody>
                    <tr>
                      <td className="font12-regular gray-500">
                        Annual Revenue
                      </td>
                      <td className="font12-regular gray-500 cln">:</td>
                      <td className="font12-medium gray-800">
                        {partnerData?.revenue_of_cus
                          ? `$${partnerData?.revenue_of_cus}`
                          : "Empty"}
                      </td>
                    </tr>
                    <tr>
                      <td className="font12-regular gray-500">
                        Years of Experience
                      </td>
                      <td className="font12-regular gray-500 cln">:</td>
                      <td className="font12-medium gray-800">
                        {partnerData?.years_of_experiences?.name}
                      </td>
                    </tr>
                  </tbody>
                </table>
                {permissions[0]?.sub_modules[5]?.permissions_actions[1]
                  ?.permission[0]?.permission === true && (
                  <div>
                    <a
                      className="font12-regular"
                      href={`/partner-filesettings/${params.partnerId}`}
                      rel="noreferrer"
                    >
                      <span>Files </span>
                      <img src="../svgs/redirect.svg" alt="redirect" />
                    </a>
                  </div>
                )}
              </Col> */}
              <Col className="col-services" xs={12}>
                <Card
                  style={{
                    border: "none",
                    minHeight: "100px",
                    verticalAlign: "center",
                    borderRadius: "0px",
                  }}
                >
                  <Grid
                    gap="2"
                    style={{ margin: "auto", padding: "0 16px" }}
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <div className="d-flex" style={{ alignItems: "center" }}>
                      <Avatar
                        style={{
                          marginRight: "12px",
                          backgroundColor: "#EFF8FF",
                          color: "#0152FB",
                          fontSize: "12.882px",
                          fontWeight: 500,
                          alignItems: "center",
                        }}
                        {...stringAvatar(
                          partnerData?.partnerv2?.name
                            ? partnerData.partnerv2.name
                            : partnerData?.name
                            ? partnerData?.name
                            : ""
                        )}
                      />
                      <Stack>
                        <h6>
                          {partnerData?.partnerv2?.name
                            ? partnerData.partnerv2.name
                            : partnerData?.name
                            ? partnerData?.name
                            : ""}
                        </h6>
                        <a
                          className="partner_website smallgrey"
                          href={
                            partnerData?.partnerv2?.website
                              ? `https://${partnerData.partnerv2.website}`
                              : partnerData?.website
                              ? `https://${partnerData.website}`
                              : ""
                          }
                          target="_blank"
                        >
                          {partnerData?.partnerv2?.website
                            ? partnerData?.partnerv2?.website
                            : partnerData?.website
                            ? partnerData?.website
                            : ""}
                          <span className="website_icon">
                            <img
                              className="mr8px"
                              src="../svgs/link.svg"
                              alt="wesite-pin"
                            />
                          </span>
                        </a>
                      </Stack>
                      <p
                        className="statusText"
                        style={getPartnerStatusTextStyle(
                          partnerData?.statusText
                        )}
                      >
                        {partnerData?.statusText}
                      </p>
                      <Stack gap="3" className="bl-gray200 ms-5 ps-4 py-2">
                        <div className="d-flex" style={{ gap: "6px" }}>
                          <img
                            width="14px"
                            className="listicon"
                            src="../svgs/shop.svg"
                            alt=""
                          />
                          <Typography
                            sx={{ fontSize: "10px", color: "#667085" }}
                          >
                            {partnerData?.partnerv2?.region?.name
                              ? partnerData?.partnerv2?.region?.name
                              : partnerData?.region?.name
                              ? partnerData?.region?.name
                              : ""}
                          </Typography>
                        </div>
                        <div className="d-flex" style={{ gap: "6px" }}>
                          <img
                            className="listicon"
                            src="../svgs/user-alternate.svg"
                            alt=""
                          />
                          <Typography
                            sx={{ fontSize: "10px", color: "#667085" }}
                          >
                            {partnerConsultants.length > 0
                              ? `${partnerConsultants[0]?.first_name} ${partnerConsultants[0]?.last_name}`
                              : ""}
                          </Typography>
                        </div>
                      </Stack>
                    </div>
                    <Stack direction="row" spacing={2}>
                      {tableName !== "suitable" ? (
                        <Button
                          onClick={() => {
                            setShowChatModal(true);
                            const chatData = {
                              brand_id: params.id,
                              partner_id: params.partnerId,
                              brandName: params?.brandName,
                              company_name: partnerData?.partnerv2?.name
                                ? partnerData.partnerv2.name
                                : partnerData?.name
                                ? partnerData?.name
                                : "",
                              market: market[0].country?.name,
                            };
                            setChatData(chatData);
                          }}
                          className="btn-ter22"
                        >
                          Chat
                        </Button>
                      ) : (
                        <></>
                      )}

                      {tableName !== "suitable" &&
                      ["super_admin", "Org_Admin"].includes(userType) &&
                      partnerData?.statusText !== "Accepted" ? (
                        <Button
                          onClick={handleAcceptInterest}
                          className="btn-primary12 adduser"
                        >
                          Accept Interest
                        </Button>
                      ) : (
                        <></>
                      )}

                      {tableName !== "suitable" &&
                      ["super_admin", "Market Consultant"].includes(
                        userType
                      ) ? (
                        <Button
                          onClick={handleRecommend}
                          className="btn-primary12 adduser"
                        >
                          Recommend
                        </Button>
                      ) : (
                        <></>
                      )}
                    </Stack>
                  </Grid>
                </Card>
                <Row>
                  <Col sm={9} lg={9} xl={9} style={{ paddingRight: "0px" }}>
                    {capabilitiesList}
                  </Col>
                  <Col sm={3} lg={3} xl={3} style={{ marginTop: "9px" }}>
                    <Card
                      style={{
                        marginTop: "9px",
                        padding: "10px 16px",
                        verticalAlign: "center",
                        borderRadius: "2px",
                        background: "#FFF",
                        borderColor: "white",
                        boxShadow:
                          "0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)",
                      }}
                    >
                      <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="flex-start"
                      >
                        <Stack
                          sx={{
                            color: "#1D2939",
                            fontSize: "14px",
                            fontWeight: "500",
                            lineHeight: "20px",
                          }}
                        >
                          Documents
                        </Stack>
                      </Grid>
                      <div className="documents-container">
                        {documents && documents.length > 0 ? (
                          documents.map((item: any) => (
                            <DocumentItem
                              name={item?.file_name}
                              path={item?.path}
                            />
                          ))
                        ) : (
                          <div
                            style={{
                              paddingRight: "0px",
                              backgroundColor: "white",
                              height: "5rem",
                              width: "100%",
                              marginTop: "20px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: "500",
                                borderRadius: "2px",
                                color: "#black",
                                fontSize: "12px",
                                padding: "4px",
                              }}
                            >
                              No Document found
                            </Typography>
                          </div>
                        )}
                      </div>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
      <ConfirmModal
        haveIcon={false}
        isModalOpen={acceptInterestModal}
        submit={onAcceptInterest}
        closeModal={closeAcceptInterestModal}
        submitBtnText="Accept"
        cancelBtnText="Cancel"
        title="Accept Interest"
        bodyText="Are you sure you want to accept partner interest ?"
      />
      <BrandApprovalPartner
        onCancel={handleCloseRecommend}
        setFlag={setFlag}
        flag={flag}
        isModalOpen={showRecommendModal}
        title="Partner Recommendation"
        subtitle="Select services which you would like to recommend to brand:"
        buttonText="Confirm Recommendation"
        userType="Admin"
        reqDetails={selectedRequest}
      />
      <ToastMessage
        notification={notification}
        onCancel={handleCloseNotification}
      />
      <PartnerChat
        isModalOpen={showChatModal}
        onCancel={() => {
          setShowChatModal(false);
        }}
        chatData={chatData}
        userID={userID}
      />
    </Container>
  );
};

export default DiscoveryPartnerProfile;
